import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import { useContent } from "../lib/useContent";
import { useSeo, Reveal, Icon, LazyImg } from "../components/common";
import { PageHero } from "../components/PageHero";
import { CTABand } from "../components/blocks";
import { fileUrl } from "../lib/api";
import { IMG } from "../data/site";

export default function Blog() {
  const { t } = useLang();
  useSeo("Blog | Sparko Cleaning Tips & Insights", "Cleaning tips, guides and industry insights from Sparko — the premium Dutch cleaning company.");
  const { data: posts } = useContent("blog");

  return (
    <div>
      <PageHero title="Sparko Blog" crumb={t.nav.blog} bg={IMG.office1}
        sub="Expert cleaning tips, guides and insights for Dutch businesses and homes." />
      <section className="mx-auto max-w-7xl px-5 md:px-8 py-24">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {posts.map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.08}>
              <Link to={`/blog/${p.slug}`} className="group block rounded-3xl bg-white border border-black/5 overflow-hidden hover-lift" data-testid={`blog-card-${p.slug}`}>
                <div className="relative h-52 overflow-hidden">
                  <LazyImg src={fileUrl(p.image)} alt={p.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  <span className="absolute top-4 start-4 rounded-full bg-blue px-3 py-1 text-xs font-semibold text-white">{p.category}</span>
                </div>
                <div className="p-6">
                  <div className="text-sm text-slate-400">{p.date} · {p.author}</div>
                  <h3 className="mt-2 font-display text-xl text-navy leading-snug group-hover:text-blue transition-colors">{p.title}</h3>
                  <p className="mt-2 text-slate-500 leading-relaxed line-clamp-2">{p.excerpt}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-blue">{t.cta.readMore} <Icon name="ArrowRight" size={15} className="rtl:rotate-180" /></span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <CTABand />
    </div>
  );
}
